import React from "react";
import { Button } from "reactstrap";
import { ContractsService } from "../../services/contract/contracts";
import { callErrorToast, callSuccessToast } from "../../utilities";
import { useAppContext } from "../../AppProvider";

const contractService = new ContractsService();

const Delete = ({ id, unmountCallback }) => {
  const { dictionary } = useAppContext();

  const deleteContract = () => {
    contractService
      .delete(id)
      .then((res) => {
        callSuccessToast(res, dictionary);
        unmountCallback();
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label>{dictionary.messages.ask_to_delete}</label>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-link" onClick={unmountCallback}>
          {dictionary.actions.cancel}
        </button>
        <Button className="btn btn-danger ms-3" onClick={deleteContract}>
          {dictionary.actions.delete}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default Delete;
